// make sure to use integers
export const SERVER_VALIDATION_STATUS_CODE = 422;

export const SUCCESS = 200;